import React, { useEffect, useState } from 'react';

const MenuList = ({ 
  currency,
  categories,
  onBackToHome,
  onAddToCart,
  setSelectedDish,
  setShowDishDetail,
  menuData,
  pageTransition
}) => {
  const isSetMenu = menuData?.menu?.is_set_menu;
  const setMenuDetail = menuData?.menu?.set_menu_detail || {};
  const [animateItems, setAnimateItems] = useState(false);

  // 控制动画的显示
  useEffect(() => {
    if (!pageTransition) {
      setTimeout(() => {
        setAnimateItems(true);
      }, 100);
    } else {
      setAnimateItems(false);
    }
  }, [pageTransition]);

  const handleDishClick = (dish, categoryName, event) => {
    // 如果点击的是按钮区域，不触发卡片的点击事件
    if (event.target.closest('button')) {
      return;
    }
    // 确保菜品对象包含所有必要的属性
    const dishWithDefaults = {
      ...dish,
      description: dish.description || {
        brief: '',
        detail: ''
      },
      allergens: dish.allergens || [],
      ingredients: dish.ingredients || [],
      cookingMethod: dish.cookingMethod || '',
      options: dish.options || [],
      addons: dish.addons || []
    };
    // 点击卡片其他区域，打开详情
    setSelectedDish(dishWithDefaults);
    setShowDishDetail(true);
  };

  const handleAddToCartClick = (event, dish, categoryName) => {
    event.stopPropagation(); // 阻止事件冒泡到卡片
    
    // 获取点击位置
    const buttonRect = event.currentTarget.getBoundingClientRect();
    const startPosition = {
      x: buttonRect.left + buttonRect.width / 2 - 16,
      y: buttonRect.top + buttonRect.height / 2 - 16
    };

    if (dish.hasOptions || dish.hasAddon) {
      // 如果有规格或附加项，打开详情弹窗
      setSelectedDish({ dish, categoryName ,currency});
      setShowDishDetail(true);
    } else {
      // 直接加入购物车
      onAddToCart(dish, categoryName, null, null, startPosition);
    }
  };

  return (
    <div className="container mx-auto pb-16">
      {/* 主要内容区域 */}
      <div className="max-w-4xl mx-auto pb-4">
        {/* 套餐信息 */}
        {isSetMenu && (
          <div className={`bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 mb-8 transition-all duration-500 ${animateItems ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-4'}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                {setMenuDetail.translation_title && (
                  <h1 className="text-2xl font-semibold text-gray-800 mb-2">
                    {setMenuDetail.translation_title}
                  </h1>
                )}
                {setMenuDetail.raw_title && (
                  <p className="text-gray-500 italic">
                    {setMenuDetail.raw_title}
                  </p>
                )}
              </div>
              <div className="text-right ml-4">
                <div className="text-2xl font-semibold text-indigo-600">
                  ¥{setMenuDetail.translation_price}
                </div>
                {setMenuDetail.raw_price > 0 && (
                  <div className="text-sm text-gray-500 mt-1">
                    {currency}{setMenuDetail.raw_price}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* 分类列表 */}
        <div className="space-y-4">
          {categories.map((category, index) => (
            <div 
              key={index} 
              className="mb-1"
            >
              <div className="category-header mb-2 glass-gradient p-1 sticky top-14 z-10" style={{ zIndex: '10' }} data-category={category.name}>
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex justify-between items-center bg-indigo-50/50 -m-1 px-4 py-2">
                      <h2 className="text-md font-medium text-gray-800">{category.name}</h2>
                      <p className="text-sm text-indigo-700">{category.translation_name}</p>
                    </div>
                    {category.description?.brief && (
                      <p className="text-gray-600 mt-4">{category.description.brief}</p>
                    )}
                  </div>
                </div>
              </div>
              
              <div className="grid grid-cols-1 gap-4 px-4">
                {category.dishes.map((dish, dishIndex) => (
                  <div
                    key={dishIndex}
                    className="bg-white/80 backdrop-blur-sm rounded-xl shadow-sm p-3 hover:shadow-md transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
                    onClick={(e) => handleDishClick(dish, category.name, e)}
                  >
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <h3 className="text-sm font-medium text-gray-800">{dish.name}</h3>
                        <p className="text-xs text-gray-500 italic">{dish.rawName}</p>
                        {dish.description.brief && (
                          <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                            {dish.description.brief}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col items-end ml-4">
                        <span className="text-lg font-semibold text-indigo-600 mb-2">
                          ¥{dish.price}
                        </span>
                        {dish.rawPrice > 0 && (
                          <p className="text-sm text-gray-500">{currency} {dish.rawPrice}</p>
                        )}
                        <button
                          onClick={(e) => handleAddToCartClick(e, dish, category.name)}
                          className="mt-2 backdrop-blur-sm bg-indigo-600/90 text-white p-2 rounded-lg hover:bg-indigo-700/90 transition-all duration-300 text-xs flex items-center"
                        >
                          {dish.hasOptions || dish.hasAddon ? (
                            <>
                              <span>选择规格</span>
                              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </>
                          ) : (
                            <>
                              <span>加入购物车</span>
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                              </svg>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuList; 